































































































































import {Component, Vue} from "vue-property-decorator";
import {Message} from "@/entity/Message";
import {XmppUtils} from "@/xmpp/XmppUtils";
import {Strophe} from "strophe.js";
import {SecurityUtils} from "@/oauth/SecurityUtils";
import {MessageJiGuangUserBody} from "@/entity/MessageJiGuangUserBody";
import {JiGuangDto} from "@/dto/JiGuangDto";
import {ajax} from "jquery";
import KeShangSelect2 from "@/views/KeShangSelect2.vue";
import {CordovaUtils} from "@/utils/CordovaUtils";
import ChatPicture from "@/components/ChatPicture.vue";
import ChatDoc from "@/components/ChatDoc.vue";
import {JiGuang} from "@/jiguang/JiGuang";

@Component({
  components: {ChatDoc, ChatPicture},
})

export default class ChatPage extends Vue {
  message1 = '';
  message = new Message();
  connection!: Strophe.Connection;
  jid = this.$route.params.jid;
  name = this.$route.params.name;
  tab1 = 'mails';
  static messages: Message[] = [];
  messages = ChatPage.messages;
  su = SecurityUtils;
  sendJid = this.su.getLoginUser().username + '@rtc1';
  user = this.su.getLoginUser();
  files: string[] = [];
  fab2 = false;

  compareDate(timeStamp: number, day: number) {
    return (this.newDate(timeStamp).getDate() == this.newDate(null).getDate() - day) && (this.newDate(timeStamp).getMonth() == this.newDate(null).getMonth()) && (this.newDate(timeStamp).getFullYear() == this.newDate(null).getFullYear())
  }

  newDate(time: any) {
    return time === null ? new Date() : new Date(time)
  }

  selectFile() {
    if (this.$refs.selectFiles != null) {
      (this.$refs.selectFiles as any).click()
    }
  }

  async openCamera() {
    const photo = await CordovaUtils.camera();
    await this.upload(photo);
  }

  openWenJianUrl(url: string) {
    window.location.href = url;
  }

  //发送文件
  upload(f: any) {
    const formData = new FormData();
    formData.append("file", f.target.files[0]);
    formData.append("system", 'customer');
    ajax({
      type: 'post',
      url: "https://fileserver.yong-gang.cn/api/uploadFile",
      dataType: 'json',
      data: formData,
      processData: false,   // jQuery不要去处理发送的数据
      contentType: false,   // jQuery不要去设置Content-Type请求头
      success: (data) => {
        this.sendd(data.data);
      }
    })
  }

  //重新发送消息
  async reSend(m: Message) {
    this.message1 = m.mes;
    const item = localStorage.getItem(XmppUtils.username + 'messages' + this.jid.substring(0, 11));
    if (item != null && item.length > 2) {
      this.messages.splice(this.messages.indexOf(m), 1);
      ChatPage.messages = this.messages;
      localStorage.setItem(XmppUtils.username + 'messages' + this.jid.substring(0, 11), JSON.stringify(this.messages));
    }
    await this.send();
  }

  //发送消息
  async send() {
    if (this.message1.trim()) {
      await XmppUtils.sendRead(this.sendJid, this.$route.params.jid);
      await XmppUtils.sendMessage(this.sendJid, this.$route.params.jid, this.message1);
      const message = new Message();
      if (ChatPage.messages.length > 0 && ChatPage.messages[ChatPage.messages.length - 1].timeStamp != null) {
        if (message.timeStamp - ChatPage.messages[ChatPage.messages.length - 1].timeStamp > 600000) {
          message.isShowTime = true;
        }
      } else {
        message.isShowTime = true;
      }
      message.mes = this.message1;
      message.sendJid = this.sendJid;
      message.receiveJid = this.$route.params.jid;
      await this.setLocalStorageMessage(message);
      await this.addRecentlyFriends();
      await this.slideDown();
      await JiGuang.sendPush(this.$route.params.jid.substring(0, 11), this.su.getLoginUser().name, this.message1);
      this.message1 = '';
    } else {
      this.$q.notify({message: '发送内容不能为空', timeout: 200});
    }
  }

  async sendd(data: any) {
    if (data) {
      await XmppUtils.sendRead(this.sendJid, this.$route.params.jid);
      const message = new Message();
      message.sendJid = this.sendJid;
      message.filePreviewUrl = data.filePreviewUrl;
      message.fileDownloadUrl = data.fileDownloadUrl;
      message.receiveJid = this.$route.params.jid;
      if (data.fileName) {
        const a = data.fileName.split('.')
        message.type = a[a.length - 1];
        let type = '';
        if (message.type === 'png' || message.type === 'jpg' || message.type === 'PNG' || message.type === 'JPG') {
          type = '[图片]'
        } else {
          type = data.fileName;
        }
        message.mes = type;
        await XmppUtils.sendFile(this.jid, this.$route.params.jid, type, a[a.length - 1], data.filePreviewUrl, data.fileDownloadUrl);
        await this.setLocalStorageMessage(message);
      }
      await this.addRecentlyFriends();
      await this.slideDown();
      await JiGuang.sendPush(this.$route.params.jid.substring(0, 11), this.su.getLoginUser().name, '文件');
    }
  }

  //添加最近联系人
  async addRecentlyFriends() {
    const recentlyFriend = KeShangSelect2.recentlyFriends.find(value => value.jid === this.jid);
    const friend = XmppUtils.friends.find(value => value.jid === this.jid);
    if (recentlyFriend == null && friend != null) {
      KeShangSelect2.recentlyFriends.push(friend);
      localStorage.setItem(XmppUtils.username + 'recentlyFriends', JSON.stringify(KeShangSelect2.recentlyFriends));
    }
  }

  //存储消息到本地
  async setLocalStorageMessage(message: Message) {
    const item = localStorage.getItem(XmppUtils.username + 'messages' + this.jid.substring(0, 11));
    if (item != null && item.length > 2) {
      this.messages = JSON.parse(item);
      this.messages.push(message);
      ChatPage.messages = this.messages;
      localStorage.setItem(XmppUtils.username + 'messages' + this.jid.substring(0, 11), JSON.stringify(this.messages));
    } else {
      const messages: Message[] = [];
      messages.push(message);
      this.messages = messages;
      ChatPage.messages = this.messages;
      localStorage.setItem(XmppUtils.username + 'messages' + this.jid.substring(0, 11), JSON.stringify(this.messages));
    }
  }

  //向下滚动
  async slideDown() {
    // setTimeout(() => {
      const height = this.$refs.slideDown as any
      if (height != null) {
        window.scrollTo(0, height.clientHeight + 10000)
      }
    // }, 100);
  }

  async getAllLocalStorageMessage() {
    const item = localStorage.getItem(XmppUtils.username + 'messages' + this.jid.substring(0, 11));
    if (item != null && item.length > 2) {
      this.messages = ChatPage.messages = JSON.parse(item);
      ChatPage.messages.forEach(value => {
        if (value.isSent === 'received') {
          value.isRead = true;
        }
      });
      localStorage.setItem(XmppUtils.username + 'messages' + this.jid.substring(0, 11), JSON.stringify(ChatPage.messages));
    }
  }

  async mounted() {
    await this.getAllLocalStorageMessage();
    await this.slideDown();
    await XmppUtils.sendRead(this.sendJid, this.$route.params.jid);
    window.addEventListener('message', (e) => {
      this.messages = ChatPage.messages;
      if (e.data === 'slideDown') {
        setTimeout(() => {
          const height = this.$refs.slideDown as any
          if (height != null) {
            window.scrollTo(0, height.clientHeight)
          }
        }, 500)
      }
    });
  }

}
